import { createProviderToken } from '@core/common-legacy'; // --FIXME

export interface PdfViewerConfig {
  CDNHost: string;
  viewerDirectory: string;
}

export const { provide: providePdfViewerConfig, inject: injectPdfViewerConfig } =
  createProviderToken<PdfViewerConfig>('PdfViewerConfig')();
